import { Component, Input } from '@angular/core';
import { ListPageColumnComponent } from 'design-system';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface AlertData {
  stato: string | null;
  valore: number | null;
  toolTip: string | null;
}

type AlertVisualState = 'success' | 'info' | 'warning' | 'danger';

@Component({
  selector: 'cus-icon-alert',
  imports: [
    CommonModule, MatTooltipModule
  ],
  templateUrl: './icon-alert.html',
  styleUrl: './icon-alert.scss',
})
export class IconAlert extends ListPageColumnComponent {
  @Input() alert: AlertData;

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.alert = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  getVisualState(): AlertVisualState {
    switch (this.alert?.stato) {
      case 'Info':
        return 'info';
      case 'Warning':
      case 'warn':
        return 'warning';
      case 'Danger':
      case 'err':
        return 'danger';
      case 'Success':
      case 'ok':
      default:
        return 'success';
    }
  }

  getIcon(): string {
    switch (this.getVisualState()) {
      case 'info':
        return 'fa-circle-info';
      case 'warning':
        return 'fa-triangle-exclamation';
      case 'danger':
        return 'fa-circle-exclamation';
      case 'success':
      default:
        return 'fa-circle-check';
    }
  }

  getCssClass(): string {
    return `alert-${this.getVisualState()}`;
  }
}
